module.exports = __webpack_public_path__ + "img/191-48273c.png";